import { eventBus } from '@/utils/eventBus'

// 创建一个封装的fetch函数
export async function request(url, options = {}) {
  // 初始化 headers
  options.headers = options.headers || {}

  // 添加token到请求头
  const token = localStorage.getItem('token')
  if (token) {
    options.headers['x-access-token'] = token
  }

  try {
    const response = await fetch(url, options)
    const data = await response.json()

    // 处理token过期的情况
    if (data.code === 30007) {
      // 清除已过期的token和用户信息
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')

      // 触发登出事件，通知 Navbar 更新状态
      eventBus.$emit('logout')

      // 跳转到登录页
      window.location.href = '/#/login'
      return null
    }

    return data
  } catch (error) {
    console.error('请求失败:', error)
    throw error
  }
}
